<sh-form-tag-list
    [id]="'dashboard-search'"
    [control]="recordSearchBarForm"
    [placeholder]="placeholderMsg"
    [styling]="recordSearchBarStyling"
    [actionItem]="recordSearchBarActionItem"
    [limitedButtons]="true"
></sh-form-tag-list>
